import { EventEmitter } from 'events'
import utils from '../utils'

function parseRuleNumber (ruleNumber) {
  let ruleArray = ruleNumber.toString(2).padStart(8, 0).split('').map(c => parseInt(c)).reverse()
  return {
    transition: (pre, self, post) => {
      let i = pre * 4 + self * 2 + post
      return ruleArray[i]
    },
    array: ruleArray,
    number: ruleNumber
  }
}

export class ElementaryCellularAutomaton extends EventEmitter {
  constructor ({ ruleNumber, size = 100 }) {
    super()
    this.size = size
    this.lattice = new Array(size).fill(0)
    this.nextl = new Array(size).fill(0)
    this.rule = parseRuleNumber(ruleNumber)
    this.age = 0
  }
  initWorld ({isRandom} = {}) {
    this.lattice.fill(0)
    this.age = 0
    if (isRandom) {
      this.lattice.forEach((v, i) => {
        this.lattice[i] = Math.random() > 0.5 ? 0 : 1
      })
    } else {
      let half = Math.floor(this.size / 2)
      this.lattice[half] = 1
    }
    this.updated()
    return this.lattice
  }
  setRule (ruleNumber) {
    this.rule = parseRuleNumber(ruleNumber)
  }
  oneStep () {
     let old = this.lattice
    this.lattice.forEach((v, i) => {
      let pre = this.lattice[utils.mod(i-1, this.size)]
      let self = this.lattice[i]
      let post = this.lattice[utils.mod(i+1, this.size)]
      this.nextl[i] = this.rule.transition(pre, self, post)
    })
    this.lattice = this.nextl
    this.nextl = old
    this.age += 1
    this.updated()
    return this.lattice
  }
  nthStep (n) {
    for (let i = 0; i < n; i++) {
      this.oneStep()
    }
    return this.lattice
  }
  updated () {
    this.emit('updated', {
      lattice: this.lattice,
      age: this.age
    })
  }
}
